module.exports = __webpack_public_path__ + "static/media/podium.8f8363dc.svg";